var YBRequest = require('../../../request')
var Parser = require('./parser')
var Log = require('../../../../log')

var DashParser = Parser.extend(
  /** @lends youbora.DashParser.prototype */
  {
    /**
     * Starts the Dash parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource The resource url.
     */
    parse: function (resource, lastManifest) {
      if (!lastManifest) {
        var request = new YBRequest(resource, null, null, { cache: true })

        request.on(YBRequest.Event.SUCCESS, function (resp) {
          this.parseLocation(resp, resource)
        }.bind(this))

        request.on(YBRequest.Event.ERROR, function (resp) {
          this.done()
        }.bind(this))

        request.send()
      } else {
        this.parseLocation(lastManifest, resource)
      }
    },

    parseLocation: function (lastManifest, resource) {
      var locationRegexp = new RegExp(/.*<Location>([\s\S]+)<\/Location>.*/)
      try {
        this._lastManifest = lastManifest
        var manifest = lastManifest.getXHR().responseText
        var matches = locationRegexp.exec(manifest)
        if (matches && matches[1]) {
          this.parse(matches[1].replace('\n', ''))
        } else {
          this.parseFinalResource(manifest, resource)
        }
      } catch (err) {
        Log.warn('Dash parse failed')
        this.done()
      }
    },

    parseFinalResource: function (manifest, resource) {
      var baseUrlRegexp = new RegExp(/[\s\S]*<BaseURL>([\s\S]+)<\/BaseURL>[\s\S]*/)
      var segmentUrlRegexp = new RegExp(/[\s\S]*<SegmentURL[\s\S]*media="([^"]+)[\s\S]*/)
      var segmentTemplateRegexp = new RegExp(/[\s\S]*<SegmentTemplate[\s\S]*media="([^"]+)[\s\S]*/)
      var matches = null
      // first: base url, second: segment url, third: segment template
      try {
        matches = baseUrlRegexp.exec(manifest) || segmentTemplateRegexp.exec(manifest) || segmentUrlRegexp.exec(manifest)
        if (matches && matches[1] && this._isFullUrl(matches[1])) {
          if (matches[1].indexOf('"') > 0) {
            this._realResource = matches[1].substr(0, matches[1].indexOf('"')).replace('\n', '')
          } else {
            this._realResource = matches[1].replace('\n', '')
          }
        } else {
          this._realResource = resource
        }
      } catch (err) {
        Log.warn('Dash manifest parse failed')
      }
      this.done()
    },

    _isFullUrl: function (url) {
      return url.indexOf('http') !== -1
    },

    shouldExecute: function (lastManifest) {
      var ret = true
      if (lastManifest) {
        var response = lastManifest.getXHR().responseText
        ret = response.indexOf('<MPD ') !== -1
      }
      return ret
    }
  }
)

module.exports = DashParser
